import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { FormRender } from '../../../../../forms/FormRenderer/types'
import FormRenderer from '../../../../../forms/FormRenderer'
import TableProductStockReservedHistorys from './TableProductStockReservedHistorys'
import useTableTypeStockSelector from '../../useTableTypeStockSelector'
import { TableProductStockBase } from '../../types'


type CheckReservedStockProductTabProps = TableProductStockBase & {}

const CheckReservedStockProductTab: React.FC<CheckReservedStockProductTabProps> = ({ isVariantProduct, productType, ...rest }) => {
    const { t } = useTwinTranslation()
    const { dictTableTypeStock, tableType, setTableType } = useTableTypeStockSelector({ isVariantProduct, productType })

    let fieldsSelectorTable: FormRender<any> = []
    if (Object.keys(dictTableTypeStock).length > 1) {
        fieldsSelectorTable.push({
            cols: 2,
            elements: [
                {
                    name: 'tableType',
                    label: t('tableType', 'Tipo de tabla'),
                    component: 'CustomSelect',
                    value: tableType,
                    items: dictTableTypeStock,
                    onChange: setTableType
                },
            ]
        })
    }
    return (
        <div className='flex flex-col mb-10 flex-auto'>
            {fieldsSelectorTable.length > 0 ? <FormRenderer sections={fieldsSelectorTable} className='mb-20' /> : null}
            <TableProductStockReservedHistorys showSpecialCases={Object.keys(dictTableTypeStock).length > 1} {...{ productType, isVariantProduct, tableType, ...rest }} />
        </div>
    )
}

export default CheckReservedStockProductTab